<!--
    描述：菜单管理页面
    时间：2020-04-22
    Created by zwh
-->
<template>
    <div class="h100">
        <w-split class="h100" v-model="splitValue">
            <div class="w-page-main left" slot="left">
                <div class="w-page-header">
                    <div class="left-text overflow-hidden">
                        <span><b>菜单列表</b></span>
                    </div>
                    <div class="btnGroups ml10">
                        <el-button type="primary" v-if="roleBtns.includes('menu_add')" size="mini" @click="addClick('addMenu', '')">新增菜单</el-button>
                    </div>
                </div>

                <div class="w-page-container pdb10">
                    <menuTreeTable
                        @row-click="rowClick"
                    ref="menuTreeTable"></menuTreeTable>
                </div>
            </div>

            <div class="w-page-main right" slot="right">
                <div class="w-page-header">
                    <div class="left-text overflow-hidden">
                        <span><b>按钮列表</b></span>
                    </div>
                    <div class="btnGroups ml10">
                        <el-button type="primary" size="mini" v-if="roleBtns.includes('btn_add')" @click="addClick('addBtn')">新增按钮</el-button>
                    </div>
                </div>
                <div class="w-page-container pdb10">
                    <btnTable  ref="btnTable"></btnTable>
                </div>
            </div>
        </w-split>
    </div>
</template>

<script>
import wSplit from 'components/split/split'
import menuTreeTable from './components/menu_tree_table'
import btnTable from './components/btn_table'
import { mapState } from 'vuex'
export default {
    components: {
        wSplit,
        menuTreeTable,
        btnTable,
    },
    data() {
        return {
            splitValue: 0.5,
        }
    },
    methods: {
        //新增按钮点击事件
        addClick(type){
            //新增菜单
            if(type==='addMenu') this.$refs.menuTreeTable.doClick('','add')
            //新增按钮
            else if(type==='addBtn') this.$refs.btnTable.doClick('','add')
        },
        //菜单点击事件
        rowClick(obj){
            let transObj = {
                menuId : obj.id,
                menuName : obj.sname,
            }
            this.$refs.btnTable.initMenuBtnInfo(transObj)
        },
    },
    // 进入缓存页面
    activated() {
        this.splitValue = 0.7
    },
    computed: {
        ...mapState('menu', {
            roleBtns: state => state.roleBtns
        })
    }
}
</script>

<style scoped lang="less">
</style>
